import { Avatar, Divider, Flex, ScrollAreaAutosize } from "@mantine/core";
import { BoxTitle, Container } from "./StyledComponents";
import styled from "styled-components";
import { theme } from "../../theme";
import { CakeIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { getLiveBirthday } from "../../api/dashboardApi";
import { useFilterContext } from "../../context/DashboardFilterContext";
import dayjs from "dayjs";

const UpcomingBirthdays = ({ flex }: { flex: any }) => {
  const { filters } = useFilterContext();
  const [employees, setEmployees] = useState<any>();

  const getBirthdays = async () => {
    try {
      const { data, success } = await getLiveBirthday(filters);
      if (success) {
        setEmployees(data?.employees);
      }
    } catch (error) {}
  };
  useEffect(() => {
    getBirthdays();
  }, [filters]);
  return (
    <Container $flex={flex}>
      <Flex h={"100%"} gap={20} direction={"column"}>
        <BoxTitle>Yaklaşan Doğum Günleri</BoxTitle>
        <ScrollAreaAutosize mah={"100%"}>
          <Flex gap={12} direction={"column"}>
            {employees?.map((employee: any, index: any) => (
              <>
                <Flex align={"center"} justify={"space-between"} gap={12}>
                  <Flex gap={12} align={"center"}>
                    <Avatar size={40}>{employee?.name[0]}</Avatar>
                    <Flex gap={4} direction={"column"}>
                      <Name>{employee?.name}</Name>
                      <Subtext>{employee?.department}</Subtext>
                    </Flex>
                  </Flex>
                  <Flex direction={"column"}>
                    <Flex gap={8} align={"center"}>
                      {employee?.status === 1 && (
                        <CakeIcon
                          color={theme.colors.brand.normal}
                          height={20}
                        />
                      )}
                      <DateText>
                        {dayjs(employee?.birthday).format("DD MMMM YYYY")}
                      </DateText>
                    </Flex>
                    <Flex justify={"end"}>
                      {employee?.daysLeft !== 0 && (
                        <DaysLeftText>
                          {employee?.daysLeft} gün kaldı
                        </DaysLeftText>
                      )}
                    </Flex>
                  </Flex>
                </Flex>
                {index !== employees?.length - 1 && <Divider />}
              </>
            ))}
          </Flex>
        </ScrollAreaAutosize>
      </Flex>
    </Container>
  );
};

export default UpcomingBirthdays;

const Name = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.greyscale.black};
`;

const DateText = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.greyscale.gray80};
`;

const DaysLeftText = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: ${theme.colors.greyscale.gray80};
`;

const Subtext = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${theme.colors.greyscale.gray80};
`;
